<div class="pr-large-t pr-medium-b">
  <h2 #headerTitle class="font-heading-3 nordic-blue-900-text" data-testid="header-heading">{{ title }}</h2>
  <ng-content />
</div>
